import IconSeeker from "./IconSeeker"

export default function LoadingIconSeeker({ ...props }) {
    return <IconSeeker icon="spinner" isSpin={true} {...props} />
}
